module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")]), _vm._v(":  S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBMARINE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARFARE")]), _vm._v("-I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENESIS IN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONNECTICUT / VII")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(":  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR TO")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARS / 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Part01"
    }
  }, [_c('b', [_vm._v("PART ONE 1914-1916")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1:  P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDATOR AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REY / 11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 2:  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTH OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH / 20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter03"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3:  S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHS OF A")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVESICK")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMAID / 29")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4:  H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNTING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBMARINES FROM")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORE / 40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5:  A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDE AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEK / 46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6:  L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USITANIA / 55")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7:  A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAKENS / 62")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 8:  P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REPARING FOR THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEVITABLE / 70")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO 1917")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 9:  A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERS THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR / 79")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 10:  C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSING THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TLANTIC / 88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 11:  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTATIVE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPS / 94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 12:  P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HYSICS")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URE AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMPLE / 101")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 13:  A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUND")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETECTOR OF")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCEEDING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELICACY / 110")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 14:  F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABORATORY TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EA / 122")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 15:  M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTERS OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE AND")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATH / 136")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 16:  A “P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBABLE")]), _vm._v("” F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL / 150")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART THREE 1918")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 17:  C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDEST")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INTER ON")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECORD / 163")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 18:  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESERVE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LYING")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORPS / 172")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 19:  L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTENERS IN THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KY / 181")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 20:  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAZY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v("—U-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOATS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWARE / 201")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 21:  I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVISIBLE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT AND")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGIC / 215")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 22:  U-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOATS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTWARD TO")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA / 228")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 23:  A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTWARD TO THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR / 240")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 24:  L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTENERS AT THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RONT AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMISTICE / 255")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PILOGUE")]), _vm._v(":  T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARS / 271")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS / 279")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES / 281")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY / 305")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX / 313")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0